import { apiRequest } from './api';

export async function sendOtp(mobileNumber) {
  return apiRequest('/api/auth/send_otp', {
    method: 'POST',
    body: JSON.stringify({ mobile_number: mobileNumber }),
  });
}

export async function verifyOtp({ token, otpCode }) {
  return apiRequest('/api/auth/verify_otp', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      otp_code: otpCode,
    }),
  });
}

export async function signup({ token, fullName, email, dateOfBirth, gender, ageGroup, district }) {
  const payload = {
    full_name: fullName,
    date_of_birth: dateOfBirth,
    gender,
    age_group: ageGroup,
    district,
    country_code: '+91',
  };
  if (email?.trim()) payload.email = email.trim();

  return apiRequest('/api/auth/signup', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
}
